import React from 'react';
import { useEditor } from '../context/EditorProvider.jsx';
import './OutputPanel.css';

export default function OutputPanel() {
  const { state } = useEditor();
  return (
    <div className="output-panel">
      <div className="output-header">Output</div>
      <pre className="output-content">
        {state.loading ? 'Running...' : state.output}
      </pre>
    </div>
  );
} 